import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useNavigate } from 'react-router-dom'
import IvrTable from '../../components/new_component/IvrTable'

import { menu, input, sip, short,  ivrSingle as ivrTranslate } from '../../translate'
import Api from '../../Api'


function Ivrs() {
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [viewMode, setViewMode] = useState('table')
  const [groups, setGroups] = useState([])
  const [filteredGroups, setFilteredGroups] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [page, setPage] = useState(0)

  useEffect(() => {
    fetchIvrs()
  }, [viewMode])

  useEffect(() => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase()
      const filtered = groups.filter(group => {
        const searchableFields = [
          group.name,
          group.virtual,
          group.noaction,
          group.cwaiting,
        ]
        return searchableFields.some(field => 
          field !== null && 
          field !== undefined && 
          String(field).toLowerCase().includes(query)
        )
      })
      setFilteredGroups(filtered)
    } else {
      setFilteredGroups(groups)
    }
    setPage(0) // Reset to first page when filter changes
  }, [searchQuery, groups])

  const fetchIvrs = async () => {
    setLoading(true)
    try {
      const response = await Api.ivrsGet()
      if (response?.data?.status === 'ok') {
        const data = response.data.data || []
        setGroups(data)
        setFilteredGroups(data)
      }
    } catch (error) {
      console.error('Error fetching IVR groups:', error)
    } finally {
      setLoading(false)
    }
  }


  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode)
    }
  }



  return (
    <Wrapper>
      {viewMode === 'table' ? (
        <>
          
          <IvrTable title={menu.ivr[langIndex]} viewMode={viewMode} onViewModeChange={handleViewModeChange} data={groups} setData={setGroups} loading={loading} />
        </>
      ) : (
        <div className="tableParent">
    
        </div>
      )}
    </Wrapper>
  )
}

export default Ivrs
